/**
 * Copyright ©2023 Drivepoint
 */

export default class EventUtilities {

  static stop(event: any): void {
    event.stopPropagation();
    event.preventDefault();
  }

}
